export function buildThemePerformance (requirements, levels) {
  const requirementsById = new Map()
  const themes = new Set()

  requirements.forEach(requirement => {
    const theme = (requirement.mandalaArea || requirement.theme || '').trim()
    const weight = Number(requirement.weight ?? 1)
    if (!theme || !Number.isFinite(weight) || weight <= 0) return

    themes.add(theme)
    requirementsById.set(String(requirement.id), { theme, weight })
  })

  const totalsByUnit = {}
  levels.forEach(answer => {
    const requirement = requirementsById.get(String(answer.requirementId))
    if (!requirement || !answer.unit || answer.levelNumber === null || answer.levelNumber === undefined || answer.levelNumber === '') return

    const level = Number(answer.levelNumber)
    if (!Number.isFinite(level) || level < 0 || level > 3) return

    const unit = totalsByUnit[answer.unit] ||= {}
    const total = unit[requirement.theme] ||= { points: 0, maximum: 0 }
    total.points += level * requirement.weight
    total.maximum += 3 * requirement.weight
  })

  const scoresByUnit = Object.fromEntries(Object.entries(totalsByUnit).map(([unit, totals]) => [
    unit,
    Object.fromEntries(Object.entries(totals).map(([theme, total]) => [theme, total.points / total.maximum * 100]))
  ]))

  return { themes: [...themes], scoresByUnit }
}

export function averageThemeScore (units, scoresByUnit, theme) {
  const scores = units.map(unit => scoresByUnit[unit.Unidade]?.[theme]).filter(score => Number.isFinite(score))
  return scores.length ? Math.round(scores.reduce((sum, score) => sum + score, 0) / scores.length) : null
}
